<template>
    <div :class="{ 'app--inactivity-locked': isInactivityLocked }">
        <NavigationProgressBar />
        <AutoModeIndicator v-if="$store.autoModeEnabled" />
        <router-view></router-view>
        <InactivityOverlay />
    </div>
</template>

<script lang="ts">
import { Watch, Component, Vue } from "vue-property-decorator";
import AutoModeIndicator from "@/components/AutoMode/AutoModeIndicator.vue";
import InactivityOverlay from "@/components/InactivityOverlay.vue";
import NavigationProgressBar from "@/components/NavigationProgressBar.vue";
import { isLockedPhase } from "@/util/inactivity/inactivityStateMachine";

@Component({
    name: "App",
    components: {
        AutoModeIndicator,
        InactivityOverlay,
        NavigationProgressBar
    }
})
export default class App extends Vue {

    // Blur and disable the app behind the inactivity lock so PHI is obscured while locked. The
    // lock dialog itself is a <b-modal> rendered into <body>, outside this root, so it stays crisp
    // and interactive.
    get isInactivityLocked(): boolean {
        return isLockedPhase(this.$root.$data.inactivityState?.phase ?? "active");
    }

    @Watch("$route", { immediate: true })
    routeUpdate(to: any, _from: any) {
        let title = to.meta.title;
        if (title == "Print Queue") title = this.$pageNames.printQueue;
        if (title == "Stale Print Queue") title = this.$pageNames.stalePrintQueue;
        document.title = title || "Scriptly";
    }

}
</script>

<style lang="scss">
.app--inactivity-locked {
    filter: blur(8px);
    pointer-events: none;
    user-select: none;
}
</style>
